export default __webpack_public_path__ + "static/media/lets_get_started.7945e186.svg";